/* ==========================================================================
   Thème Soleria — scripts
   Tout est en JavaScript natif, sans dépendance externe.
   ========================================================================== */
(function () {
  'use strict';

  var MONEY_FORMAT = (window.Shopify && window.Shopify.money_format) || '{{amount_with_comma_separator}} €';

  /* ---------------------------------------------------------------------
     Utilitaires
     --------------------------------------------------------------------- */
  function formatMoney(cents) {
    if (typeof cents !== 'number') cents = parseInt(cents, 10) || 0;
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var integer = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    if (MONEY_FORMAT.indexOf('comma_separator') > -1) {
      return MONEY_FORMAT.replace(/\{\{\s*\w+\s*\}\}/, integer + ',' + parts[1]);
    }
    return MONEY_FORMAT.replace(/\{\{\s*\w+\s*\}\}/, integer + '.' + parts[1]);
  }

  function showToast(message) {
    var toast = document.getElementById('ToastRegion');
    if (!toast) return;
    toast.textContent = message;
    toast.hidden = false;
    clearTimeout(toast._timer);
    toast._timer = setTimeout(function () {
      toast.hidden = true;
    }, 3000);
  }

  function trapFocusEscape(callback) {
    function onKey(event) {
      if (event.key === 'Escape') {
        callback();
        document.removeEventListener('keydown', onKey);
      }
    }
    document.addEventListener('keydown', onKey);
  }

  /* ---------------------------------------------------------------------
     Menu mobile & recherche
     --------------------------------------------------------------------- */
  function initHeader(scope) {
    var root = scope || document;

    root.querySelectorAll('[data-mobile-nav-open]').forEach(function (button) {
      button.addEventListener('click', function () {
        var nav = document.querySelector('[data-mobile-nav]');
        var overlay = document.querySelector('[data-mobile-nav-overlay]');
        if (!nav) return;
        nav.classList.add('is-open');
        if (overlay) overlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        button.setAttribute('aria-expanded', 'true');
        trapFocusEscape(closeMobileNav);
      });
    });

    function closeMobileNav() {
      var nav = document.querySelector('[data-mobile-nav]');
      var overlay = document.querySelector('[data-mobile-nav-overlay]');
      if (nav) nav.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      document.querySelectorAll('[data-mobile-nav-open]').forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
    }

    root.querySelectorAll('[data-mobile-nav-close], [data-mobile-nav-overlay]').forEach(function (element) {
      element.addEventListener('click', closeMobileNav);
    });

    // Sous-menus mobiles
    root.querySelectorAll('[data-mobile-submenu-toggle]').forEach(function (button) {
      button.addEventListener('click', function () {
        var panel = button.nextElementSibling;
        if (!panel) return;
        var isOpen = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!isOpen));
        panel.style.maxHeight = isOpen ? '0px' : panel.scrollHeight + 'px';
      });
    });

    // Recherche
    root.querySelectorAll('[data-search-toggle]').forEach(function (button) {
      button.addEventListener('click', function () {
        var drawer = document.querySelector('[data-search-drawer]');
        if (!drawer) return;
        var isOpen = drawer.classList.toggle('is-open');
        if (isOpen) {
          var input = drawer.querySelector('input[type="search"]');
          if (input) input.focus();
          trapFocusEscape(function () {
            drawer.classList.remove('is-open');
          });
        }
      });
    });

    root.querySelectorAll('[data-search-close]').forEach(function (button) {
      button.addEventListener('click', function () {
        var drawer = document.querySelector('[data-search-drawer]');
        if (drawer) drawer.classList.remove('is-open');
      });
    });
  }

  /* ---------------------------------------------------------------------
     Barre d'annonce (rotation)
     --------------------------------------------------------------------- */
  function initAnnouncement(scope) {
    (scope || document).querySelectorAll('[data-announcement]').forEach(function (bar) {
      var slides = bar.querySelectorAll('.announcement-bar__slide');
      if (slides.length < 2) return;
      var speed = parseInt(bar.dataset.speed, 10) || 5;
      var index = 0;
      setInterval(function () {
        slides[index].classList.remove('is-active');
        index = (index + 1) % slides.length;
        slides[index].classList.add('is-active');
      }, speed * 1000);
    });
  }

  /* ---------------------------------------------------------------------
     Accordéons
     --------------------------------------------------------------------- */
  function initAccordions(scope) {
    (scope || document).querySelectorAll('[data-accordion-toggle]').forEach(function (button) {
      if (button._bound) return;
      button._bound = true;
      button.addEventListener('click', function () {
        var panel = document.getElementById(button.getAttribute('aria-controls'));
        var expanded = button.getAttribute('aria-expanded') === 'true';
        var group = button.closest('[data-accordion]');

        if (group && group.dataset.singleOpen === 'true' && !expanded) {
          group.querySelectorAll('[data-accordion-toggle][aria-expanded="true"]').forEach(function (other) {
            other.setAttribute('aria-expanded', 'false');
            var otherPanel = document.getElementById(other.getAttribute('aria-controls'));
            if (otherPanel) otherPanel.style.maxHeight = '0px';
          });
        }

        button.setAttribute('aria-expanded', String(!expanded));
        if (panel) panel.style.maxHeight = expanded ? '0px' : panel.scrollHeight + 'px';
      });
    });
  }

  /* ---------------------------------------------------------------------
     Carrousels
     --------------------------------------------------------------------- */
  function initCarousels(scope) {
    (scope || document).querySelectorAll('[data-carousel]').forEach(function (carousel) {
      var track = carousel.querySelector('[data-carousel-track]');
      if (!track) return;
      var prev = carousel.querySelector('[data-carousel-prev]');
      var next = carousel.querySelector('[data-carousel-next]');
      var dots = carousel.querySelectorAll('[data-carousel-dot]');

      function scrollAmount() {
        var slide = track.querySelector('.carousel__slide');
        return slide ? slide.offsetWidth + 16 : track.offsetWidth * 0.8;
      }

      if (prev) {
        prev.addEventListener('click', function () {
          track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
        });
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          track.scrollTo({ left: scrollAmount() * i, behavior: 'smooth' });
        });
      });

      track.addEventListener(
        'scroll',
        function () {
          if (!dots.length) return;
          var current = Math.round(track.scrollLeft / scrollAmount());
          dots.forEach(function (dot, i) {
            dot.setAttribute('aria-current', String(i === current));
          });
        },
        { passive: true }
      );

      // Défilement automatique facultatif
      var autoplay = parseInt(carousel.dataset.autoplay, 10);
      if (autoplay > 0) {
        var timer = setInterval(function () {
          if (track.scrollLeft + track.offsetWidth >= track.scrollWidth - 5) {
            track.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
          }
        }, autoplay * 1000);
        carousel.addEventListener('mouseenter', function () {
          clearInterval(timer);
        });
      }
    });
  }

  /* ---------------------------------------------------------------------
     Diaporama de la bannière (hero)
     --------------------------------------------------------------------- */
  function initSlideshow(scope) {
    (scope || document).querySelectorAll('[data-slideshow]').forEach(function (slideshow) {
      var slides = slideshow.querySelectorAll('[data-slide]');
      if (slides.length < 2) return;
      var dots = slideshow.querySelectorAll('[data-slideshow-dot]');
      var index = 0;
      var speed = parseInt(slideshow.dataset.speed, 10) || 6;

      function goTo(i) {
        slides[index].style.display = 'none';
        index = (i + slides.length) % slides.length;
        slides[index].style.display = 'flex';
        dots.forEach(function (dot, d) {
          dot.setAttribute('aria-current', String(d === index));
        });
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          goTo(i);
        });
      });

      if (slideshow.dataset.autoplay === 'true') {
        setInterval(function () {
          goTo(index + 1);
        }, speed * 1000);
      }
    });
  }

  /* ---------------------------------------------------------------------
     Galerie produit
     --------------------------------------------------------------------- */
  function initProductGallery(scope) {
    (scope || document).querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var target = thumb.dataset.galleryThumb;
          gallery.querySelectorAll('[data-gallery-item]').forEach(function (item) {
            item.classList.toggle('is-active', item.dataset.galleryItem === target);
          });
          gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (other) {
            other.setAttribute('aria-current', String(other === thumb));
          });
        });
      });
    });
  }

  /* ---------------------------------------------------------------------
     Sélecteur de variantes
     --------------------------------------------------------------------- */
  function initVariantPicker(scope) {
    (scope || document).querySelectorAll('[data-variant-picker]').forEach(function (picker) {
      var sectionId = picker.dataset.section;
      var dataEl = document.querySelector('[data-variant-json="' + sectionId + '"]');
      if (!dataEl) return;

      var variants = JSON.parse(dataEl.textContent);
      var form = document.querySelector('[data-product-form="' + sectionId + '"]');
      var idInput = form ? form.querySelector('[name="id"]') : null;
      var priceEl = document.querySelector('[data-product-price="' + sectionId + '"]');
      var submitEl = form ? form.querySelector('[data-add-to-cart]') : null;
      var stickyPrice = document.querySelector('[data-sticky-price="' + sectionId + '"]');

      function currentOptions() {
        var options = [];
        picker.querySelectorAll('[data-option-index]').forEach(function (input) {
          if (input.type === 'radio') {
            if (input.checked) options[parseInt(input.dataset.optionIndex, 10)] = input.value;
          } else {
            options[parseInt(input.dataset.optionIndex, 10)] = input.value;
          }
        });
        return options;
      }

      function findVariant() {
        var selectedId = picker.querySelector('[data-variant-id]:checked');
        if (selectedId) {
          var id = parseInt(selectedId.value, 10);
          for (var i = 0; i < variants.length; i++) {
            if (variants[i].id === id) return variants[i];
          }
          return null;
        }
        var options = currentOptions();
        return (
          variants.filter(function (variant) {
            return options.every(function (value, index) {
              return variant.options[index] === value;
            });
          })[0] || null
        );
      }

      function renderPrice(variant) {
        if (!priceEl) return;
        var html = '<span class="price__current">' + formatMoney(variant.price) + '</span>';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += '<span class="price__compare">' + formatMoney(variant.compare_at_price) + '</span>';
        }
        priceEl.innerHTML = html;
        if (stickyPrice) stickyPrice.innerHTML = formatMoney(variant.price);
      }

      function update() {
        var variant = findVariant();

        if (!variant) {
          if (submitEl) {
            submitEl.setAttribute('disabled', 'disabled');
            submitEl.textContent = 'Indisponible';
          }
          return;
        }

        if (idInput) idInput.value = variant.id;
        renderPrice(variant);

        if (submitEl) {
          if (variant.available) {
            submitEl.removeAttribute('disabled');
            submitEl.textContent = submitEl.dataset.defaultLabel || 'Ajouter au panier';
          } else {
            submitEl.setAttribute('disabled', 'disabled');
            submitEl.textContent = 'Épuisé';
          }
        }

        // Image liée à la variante
        if (variant.featured_media) {
          var gallery = document.querySelector('[data-product-gallery]');
          if (gallery) {
            var target = String(variant.featured_media.id);
            var item = gallery.querySelector('[data-gallery-item="' + target + '"]');
            if (item) {
              gallery.querySelectorAll('[data-gallery-item]').forEach(function (el) {
                el.classList.toggle('is-active', el === item);
              });
              gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
                thumb.setAttribute('aria-current', String(thumb.dataset.galleryThumb === target));
              });
            }
          }
        }

        if (window.history.replaceState && picker.dataset.updateUrl !== 'false') {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      picker.addEventListener('change', update);
      update();
    });
  }

  /* ---------------------------------------------------------------------
     Sélecteur de quantité
     --------------------------------------------------------------------- */
  function initQuantity(scope) {
    (scope || document).querySelectorAll('[data-quantity]').forEach(function (wrapper) {
      var input = wrapper.querySelector('input');
      wrapper.querySelectorAll('[data-quantity-change]').forEach(function (button) {
        button.addEventListener('click', function () {
          var step = parseInt(button.dataset.quantityChange, 10);
          var value = parseInt(input.value, 10) + step;
          var min = parseInt(input.min, 10) || 1;
          input.value = value < min ? min : value;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------------------------------------------------------------------
     Barre d'achat collante (mobile)
     --------------------------------------------------------------------- */
  function initStickyAtc(scope) {
    (scope || document).querySelectorAll('[data-sticky-atc]').forEach(function (bar) {
      var trigger = document.querySelector('[data-sticky-trigger]');
      if (!trigger || !('IntersectionObserver' in window)) return;
      var observer = new IntersectionObserver(
        function (entries) {
          bar.classList.toggle('is-visible', !entries[0].isIntersecting);
        },
        { rootMargin: '0px 0px -100% 0px' }
      );
      observer.observe(trigger);
    });
  }

  /* ---------------------------------------------------------------------
     Comparateur avant / après
     --------------------------------------------------------------------- */
  function initBeforeAfter(scope) {
    (scope || document).querySelectorAll('[data-before-after]').forEach(function (widget) {
      var after = widget.querySelector('[data-ba-after]');
      var handle = widget.querySelector('[data-ba-handle]');
      if (!after || !handle) return;
      var dragging = false;

      function setPosition(clientX) {
        var rect = widget.getBoundingClientRect();
        var percent = ((clientX - rect.left) / rect.width) * 100;
        percent = Math.max(2, Math.min(98, percent));
        after.style.width = percent + '%';
        handle.style.left = percent + '%';
      }

      handle.addEventListener('mousedown', function () {
        dragging = true;
      });
      window.addEventListener('mouseup', function () {
        dragging = false;
      });
      window.addEventListener('mousemove', function (event) {
        if (dragging) setPosition(event.clientX);
      });

      handle.addEventListener(
        'touchstart',
        function () {
          dragging = true;
        },
        { passive: true }
      );
      window.addEventListener('touchend', function () {
        dragging = false;
      });
      window.addEventListener(
        'touchmove',
        function (event) {
          if (dragging && event.touches[0]) setPosition(event.touches[0].clientX);
        },
        { passive: true }
      );

      widget.addEventListener('click', function (event) {
        setPosition(event.clientX);
      });

      handle.addEventListener('keydown', function (event) {
        var currentWidth = parseFloat(after.style.width) || 50;
        if (event.key === 'ArrowLeft') currentWidth -= 5;
        if (event.key === 'ArrowRight') currentWidth += 5;
        currentWidth = Math.max(2, Math.min(98, currentWidth));
        after.style.width = currentWidth + '%';
        handle.style.left = currentWidth + '%';
      });
    });
  }

  /* ---------------------------------------------------------------------
     Filtres de collection (soumission automatique)
     --------------------------------------------------------------------- */
  function initFacets(scope) {
    (scope || document).querySelectorAll('[data-facets-form]').forEach(function (form) {
      form.addEventListener('change', function () {
        form.submit();
      });
    });

    (scope || document).querySelectorAll('[data-sort-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  /* ---------------------------------------------------------------------
     Ajout au panier en AJAX
     --------------------------------------------------------------------- */
  function initAjaxCart(scope) {
    (scope || document).querySelectorAll('[data-product-form][data-ajax="true"]').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var button = form.querySelector('[data-add-to-cart]');
        var originalLabel = button ? button.textContent : '';
        if (button) {
          button.setAttribute('disabled', 'disabled');
          button.textContent = 'Ajout en cours…';
        }

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [
              {
                id: form.querySelector('[name="id"]').value,
                quantity: parseInt((form.querySelector('[name="quantity"]') || {}).value || 1, 10)
              }
            ]
          })
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (data) {
            if (data.status) {
              showToast(data.description || data.message);
            } else {
              showToast('Produit ajouté au panier ✓');
              refreshCartCount();
            }
          })
          .catch(function () {
            showToast("Une erreur est survenue, merci de réessayer.");
          })
          .finally(function () {
            if (button) {
              button.removeAttribute('disabled');
              button.textContent = originalLabel;
            }
          });
      });
    });
  }

  function refreshCartCount() {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (element) {
          element.textContent = cart.item_count;
          element.hidden = cart.item_count === 0;
        });
      });
  }

  /* ---------------------------------------------------------------------
     Initialisation
     --------------------------------------------------------------------- */
  function initAll(scope) {
    initHeader(scope);
    initAnnouncement(scope);
    initAccordions(scope);
    initCarousels(scope);
    initSlideshow(scope);
    initProductGallery(scope);
    initVariantPicker(scope);
    initQuantity(scope);
    initStickyAtc(scope);
    initBeforeAfter(scope);
    initFacets(scope);
    initAjaxCart(scope);
  }

  if (document.readyState !== 'loading') {
    initAll(document);
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  }

  // Compatibilité avec l'éditeur de thème Shopify
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
  document.addEventListener('shopify:section:select', function (event) {
    initAll(event.target);
  });
})();
